import { useAccess } from '../../../accessControl/useAccess';
import { openFreemiumUpsell } from '../../../stores/freemiumUpsellStore';

/**
 * Bloqueio de conteúdo de disciplina para o freemium.
 *
 * `isLocked(item)` indica se o card deve exibir o cadeado (freemium sem a tag);
 * `openLock` abre o modal global de upsell. O modal é único e vive no topo da
 * app (GlobalFreemiumUpsell), então os consumidores não precisam mais manter
 * estado local nem renderizar o modal.
 */
export function useFreemiumLock() {
  const { isFreemium, isContentLocked, isFreemiumUnlocked } = useAccess();

  return {
    isFreemium,
    isLocked: isContentLocked,
    isUnlocked: isFreemiumUnlocked,
    openLock: openFreemiumUpsell,
  };
}
